import { useState } from 'react'

import { EmailShowConversationButton } from '../../../EmailShowConversationButton'

import * as styles from './MessageText.module.css'

function MessageText({ children, className = styles.MessageText }) {
  const [isExpanded, setExpanded] = useState(false)

  function handleClickShowConversation() {
    setExpanded(prevExpanded => !prevExpanded)
  }

  return (
    <div className={className}>
      <EmailShowConversationButton
        isActive={isExpanded}
        onClick={handleClickShowConversation}
      />
      {isExpanded ? children : null}
    </div>
  )
}

export default MessageText
